import React, { useEffect, useState } from "react";

const slides = [
  {
    id: "banquet-hero-1",
    desktopSrc: "/images/banners/banquet-hero-desktop.png",
    mobileSrc: "/images/banners/banquet-hero-mobile.png",
    alt: "DecorZoom banquet hero banner",
  },
];

export default function BanquetHeroSlider({ onBannerClick }) {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) {
      return undefined;
    }

    const timer = window.setInterval(() => {
      setActiveIndex((current) => (current + 1) % slides.length);
    }, 5000);

    return () => window.clearInterval(timer);
  }, []);

  return (
    <section className="px-3 pt-3 sm:px-4 sm:pt-5">
      <div className="mx-auto max-w-7xl">
        <div className="relative overflow-hidden rounded-[18px] bg-slate-200 shadow-[0_20px_45px_-28px_rgba(15,23,42,0.35)] sm:rounded-[28px]">
          {slides.map((slide, index) => (
            <button
              key={slide.id}
              type="button"
              onClick={onBannerClick}
              aria-label="Scroll to banquet listings"
              className={`absolute inset-0 block h-full w-full transition-opacity duration-700 ${
                index === activeIndex ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"
              }`}
            >
              <picture>
                <source media="(max-width: 767px)" srcSet={slide.mobileSrc} />
                <img src={slide.desktopSrc} alt={slide.alt} className="h-full w-full object-cover object-center" />
              </picture>
            </button>
          ))}

          <div className="pointer-events-none w-full pt-[70%] sm:pt-[28%] lg:pt-[20%]" />

          {slides.length > 1 && (
            <div className="absolute bottom-3 left-1/2 flex -translate-x-1/2 gap-2">
              {slides.map((slide, index) => (
                <button
                  key={slide.id}
                  type="button"
                  onClick={() => setActiveIndex(index)}
                  aria-label={`Go to slide ${index + 1}`}
                  className={`h-2.5 rounded-full transition-all ${index === activeIndex ? "w-6 bg-white" : "w-2.5 bg-white/60"}`}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
